import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FieldProps } from "formik";
import ReactNumberFormat from "react-number-format";

import cx from "clsx";
import _get from "lodash/get";

import createRequest from "helpers/createRequest";
import Preloader from "components/Preloader";

export interface PhoneInputProps extends FieldProps {
  label?: string;
  placeholder?: string;
  checkExist?: boolean;
  onChange?(value: string): void;
}

export default ({
  label,
  placeholder = "+998",
  checkExist = false,
  field,
  form,
  onChange = () => {}
}: PhoneInputProps) => {
  const { t } = useTranslation();

  const [asyncValidation, onValidate] = useState({
    loading: false,
    error: ""
  });

  const touched = form.touched[field.name];
  const error = form.errors[field.name];

  const inputClasses = cx("form-control", {
    "is-invalid": touched && (error || asyncValidation.error),
    "is-valid": touched && !(error || asyncValidation.error)
  });

  const feedbackClasses = cx({
    "invalid-feedback": touched && (error || asyncValidation.error),
    "valid-feedback": touched && !(error || asyncValidation.error)
  });

  const asyncValidate = () => {
    onValidate({ ...asyncValidation, loading: true });

    createRequest
      .get("/validate/users", {
        params: {
          phone_number: field.value
        }
      })
      .then(() => {
        onValidate({ loading: false, error: "" });
      })
      .catch(error => {
        onValidate({ loading: false, error: t("global.validation.phone_exists") });
      });
  };

  return (
    <Preloader loading={asyncValidation.loading} small>
      <div className="form-group">
        {label && <label className="control-label">{label}</label>}
        <ReactNumberFormat
          className={inputClasses}
          placeholder={placeholder}
          displayType="input"
          format="+### ## ###-##-##"
          value={field.value}
          onValueChange={({ value }) => {
            form.setFieldValue(field.name, value);
            onChange(value);
          }}
          onBlur={() => {
            if (checkExist && field.value) {
              asyncValidate();
            }
            form.setFieldTouched(field.name, true);
          }}
        />

        {touched && (error || asyncValidation.error) && (
          <div className={feedbackClasses}>{error || asyncValidation.error}</div>
        )}
      </div>
    </Preloader>
  );
};
